import _extends from '@babel/runtime/helpers/extends';
import { makeStyles, LayoutGrid, Icon } from '@archer-technologies/ui-components';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { createElement } from 'react';
var useStyles = makeStyles(function () {
  return {
    checkCellStyles: {
      textAlign: 'center',
      lineHeight: 1
    }
  };
});

var CheckFormatter = function CheckFormatter(_ref) {
  var value = _ref.value;

  var _useStyles = useStyles(),
      checkCellStyles = _useStyles.checkCellStyles;

  return value && /*#__PURE__*/createElement(LayoutGrid, {
    className: checkCellStyles
  }, /*#__PURE__*/createElement(Icon, {
    icon: "Check",
    fontSize: "medium"
  }));
};

var CheckTypeProvider = function CheckTypeProvider(props) {
  return /*#__PURE__*/createElement(DataTypeProvider, _extends({
    formatterComponent: CheckFormatter
  }, props));
};

export { CheckTypeProvider };